import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetUsersMeNotification_settings = z.any()
export type TagsGetUsersMeNotification_settings = z.infer<typeof tagsGetUsersMeNotification_settings>

export const descriptionGetUsersMeNotification_settings = z.any()
export type DescriptionGetUsersMeNotification_settings = z.infer<typeof descriptionGetUsersMeNotification_settings>

export const responseGetUsersMeNotification_settings = z.object({ "payload": z.object({ "collectionPointDeletionEmailEnabled": z.boolean(), "obligationAlertEmailEnabled": z.boolean(), "consumptionDeviationDigestEnabled": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetUsersMeNotification_settings = z.infer<typeof responseGetUsersMeNotification_settings>

interface IGetUsersMeNotification_settings extends BaseMethodType {
  tags: TagsGetUsersMeNotification_settings,
  description: DescriptionGetUsersMeNotification_settings,
  response: ResponseGetUsersMeNotification_settings
}
export const tagsPatchUsersMeNotification_settings = z.any()
export type TagsPatchUsersMeNotification_settings = z.infer<typeof tagsPatchUsersMeNotification_settings>

export const descriptionPatchUsersMeNotification_settings = z.any()
export type DescriptionPatchUsersMeNotification_settings = z.infer<typeof descriptionPatchUsersMeNotification_settings>

export const bodyPatchUsersMeNotification_settings = z.object({ "collectionPointDeletionEmailEnabled": z.boolean().optional(), "obligationAlertEmailEnabled": z.boolean().optional(), "consumptionDeviationDigestEnabled": z.boolean().optional() }).strict()
export type BodyPatchUsersMeNotification_settings = z.infer<typeof bodyPatchUsersMeNotification_settings>

export const responsePatchUsersMeNotification_settings = z.object({ "payload": z.object({ "collectionPointDeletionEmailEnabled": z.boolean(), "obligationAlertEmailEnabled": z.boolean(), "consumptionDeviationDigestEnabled": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchUsersMeNotification_settings = z.infer<typeof responsePatchUsersMeNotification_settings>

interface IPatchUsersMeNotification_settings extends BaseMethodType {
  tags: TagsPatchUsersMeNotification_settings,
  description: DescriptionPatchUsersMeNotification_settings,
  body: BodyPatchUsersMeNotification_settings,
  response: ResponsePatchUsersMeNotification_settings
}
export const URL = '/users/me/notification-settings'
export const validation = {
  get: {
    tags: tagsGetUsersMeNotification_settings,
    description: descriptionGetUsersMeNotification_settings,
    response: responseGetUsersMeNotification_settings
  },
  patch: {
    tags: tagsPatchUsersMeNotification_settings,
    description: descriptionPatchUsersMeNotification_settings,
    body: bodyPatchUsersMeNotification_settings,
    response: responsePatchUsersMeNotification_settings
  }
}
export interface UsersMeNotification_settings extends BaseRouteType {
  get: IGetUsersMeNotification_settings,
  patch: IPatchUsersMeNotification_settings
}